import React from 'react';

import DotSignifier from '../../../components/DotSignifier';
import * as Style from '../style.module.scss';
import { Checklist } from '../types';
import CareTable from './CareTable';

const STEP_LABELS: Record<string, string> = {
    stage1_baseline: 'Population',
    imports_valid: 'Imports',
    matching_resolved: 'Matching',
    run_current: 'Qualification run',
    outcomes_resolved: 'Outcomes',
    lock_recorded: 'Lock'
};

const ChecklistPanel: React.FC<{ checklist?: Checklist }> = ({ checklist }) => (
    <CareTable
        collapsible
        title={
            checklist
                ? `Progress — ${checklist.done_steps} of ${checklist.total_steps} steps done`
                : 'Progress'
        }
        columns={['', 'Step', 'Status']}
        gridTemplateColumns="3rem 1fr 3fr"
        rows={checklist?.steps.map((step) => [
            <div key="dot" className={Style.checklistDot}>
                <DotSignifier type={step.done ? 'success' : 'fail'} />
            </div>,
            STEP_LABELS[step.step] ?? step.step,
            step.explanation
        ])}
        explanations={checklist ? [checklist.explanation] : []}
    />
);

export default ChecklistPanel;
